import { observable, computed } from 'mobx';
import User from 'helper/currentUser';

import { ParticipantType, RoomStatus } from 'components/LiveClass/utils/consts';
import { ReportingLibrary } from '@lyearn-team/reporting-library';
import RoomStore from './RoomStore';
import ParticipantsStore from './ParticipantsStore';
import JoinLiveClassStore from './JoinLiveClassStore';
import EndLiveClassStore from './EndLiveClassStore';
import MembersDrawerStore from './MembersDrawerStore';
import LocalUserMediaStore from './LocalUserMediaStore';
import ProgressSyncStore from './ProgressSyncStore';
import ActivityStore from './ActivityStore';

const user = new User();

class RootStore {
  reportingLibrary = new ReportingLibrary();

  userId = '';

  companyId = '';

  classId = '';

  @observable isMobile = window.innerWidth < 768;

  @observable.ref participantType = ParticipantType.Teacher;

  joinLiveClass = new JoinLiveClassStore(this);

  endLiveClass = new EndLiveClassStore(this);

  membersDrawer = new MembersDrawerStore(this);

  room = new RoomStore(this);

  localUserMedia = new LocalUserMediaStore(this);

  participants = new ParticipantsStore(this);

  activity = new ActivityStore(this);

  progressSync = new ProgressSyncStore(this);

  @computed
  get isTeacher() {
    return this.participantType === ParticipantType.Teacher;
  }

  @computed
  get isRoomConnected() {
    return this.room.roomStatus === RoomStatus.Connected;
  }

  sync() {
    this.userId = user.id();
    this.companyId = user.companyId();

    this.localUserMedia.sync({ userId: this.userId });
  }
}

export default RootStore;
